import React, { FC, useEffect, useState } from 'react';
import { ImproveProjectFormProps } from './ImproveProjectFormProps';
import ProjectDetailsFields from '../ProjectDetailsFields';
import ProjectConfidentialButton from '../ProjectConfidentialButton';
import Divider from '../../Divider';
import ProjectInformationFields from '../ProjectInformationFields';
import ProjectDatesFields from '../ProjectDatesFields';
import ProjectProgrammeNameSelect from '../ProjectProgrammeNameSelect';
import DesignStartDates from '../DesignStartDates';
import useTranslation from '../../../hooks/useTranslation';
import Text from '@ingka/text';
import InlineMessage from '@ingka/inline-message';
import PartOfCrpForm from '../PartOfCrpForm';

const ImproveProjectForm: FC<ImproveProjectFormProps> = ({
  projectList,
  isConfidentialAllowed,
  isep,
  programName,
  isRealEstateSisan,
}) => {
  const t = useTranslation();
  const [programmeName, setProgrammeName] = useState(programName);

  useEffect(() => {
    if (programName !== null) {
      setProgrammeName(programName);
    }
  }, [programName]);

  return (
    <>
      {programmeName && (
        <InlineMessage
          body={t('flight.createSubmissionModal.capacity_info_programme')}
          variant={'cautionary'}
        />
      )}
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDetails')}
      </Text>
      <ProjectDetailsFields
        projectList={projectList}
        unifier={isep}
        isRealEstateSisan={isRealEstateSisan}
        type={'Improve'}
      />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
      <Divider />
      <PartOfCrpForm />
      <Divider />
      <ProjectInformationFields />
      <Divider />
      <ProjectDatesFields
        openingDate
        initialDates
        projectClosingDate
        isep={isep}
      />
      <Divider />
      <DesignStartDates />
      <Divider />
      <ProjectProgrammeNameSelect onProgrammeChange={setProgrammeName} />
    </>
  );
};

export default ImproveProjectForm;
